import axios from "axios";

async function invokeApi(url, verb = "get", payload = null) {
  const { REACT_APP_BASE_URL_PROD, REACT_APP_STAGE_API } = process.env;

  let apiUrl = REACT_APP_BASE_URL_PROD.concat(REACT_APP_STAGE_API);
  apiUrl = apiUrl.concat(url);

  const config = {
    headers: {
      Accept: "application/json",
    },
  };

  function call() {
    switch (verb) {
      case "get":
        return axios.get(apiUrl, config);
      case "post":
        return axios.post(apiUrl, payload, config);
      case "put":
        return axios.put(apiUrl, payload, config);
      case "delete":
        return axios.delete(apiUrl, config);
      default:
        return axios.get(apiUrl, config);
    }
  }

  // Helper function para construir respuestas de error consistentes
  const buildErrorResponse = (errorData) => {
    return {
      error: {
        ...errorData,
        timestamp: new Date().toISOString()
      }
    };
  };

  // Helper function para mapear códigos HTTP a categorías
  const mapHttpCodeToStatus = (status) => {
    if (status >= 400 && status < 500) {
      switch (status) {
        case 400: return "BAD_REQUEST";
        case 401: return "UNAUTHORIZED";
        case 403: return "FORBIDDEN";
        case 404: return "NOT_FOUND";
        case 422: return "UNPROCESSABLE_ENTITY";
        case 429: return "TOO_MANY_REQUESTS";
        default: return "CLIENT_ERROR";
      }
    }
    if (status >= 500) {
      switch (status) {
        case 500: return "INTERNAL_SERVER_ERROR";
        case 502: return "BAD_GATEWAY";
        case 503: return "SERVICE_UNAVAILABLE";
        case 504: return "GATEWAY_TIMEOUT";
        default: return "SERVER_ERROR";
      }
    }
    return "UNKNOWN_HTTP_ERROR";
  };

  // Helper function para mapear códigos de aplicación a categorías
  const mapAppCodeToStatus = (statusCode) => {
    switch (statusCode) {
      case 400: return "VALIDATION_ERROR";
      case 401: return "AUTHENTICATION_ERROR";
      case 403: return "PERMISSION_DENIED";
      case 404: return "RESOURCE_NOT_FOUND";
      case 409: return "CONFLICT";
      case 422: return "VALIDATION_FAILED";
      case 500: return "APPLICATION_ERROR";
      default: return "APPLICATION_ERROR";
    }
  };

  try {
    const resp = await call();
    
    // Aquí SOLO llegan códigos HTTP 200
    
    // ✅ ÉXITO: HTTP=200 Y App=200
    if (resp.data?.statusCode === 200) {
      return resp.data;
    }
    
    // ⚠️ ERROR DE APLICACIÓN: HTTP=200 PERO App≠200
    if (resp.data?.statusCode && resp.data.statusCode !== 200) {
      return buildErrorResponse({
        code: resp.data.statusCode,
        status: mapAppCodeToStatus(resp.data.statusCode),
        message: resp.data.message || `Application error ${resp.data.statusCode}`,
        httpStatus: 200,
        httpStatusText: "OK",
        axiosCode: null,
        serverStatusCode: resp.data.statusCode,
        serverData: resp.data
      });
    }
    
    // 🚨 LAMBDA MALFORMADA: HTTP=200 pero sin statusCode
    return buildErrorResponse({
      code: 502,
      status: "MALFORMED_RESPONSE",
      message: "Lambda response missing statusCode",
      httpStatus: 200,
      httpStatusText: "OK",
      axiosCode: null,
      serverStatusCode: null,
      serverData: resp.data
    });
    
  } catch (error) {
    console.error("API call error:", error);
    
    // Aquí llegan TODOS los códigos HTTP ≠ 200
    
    // ❌ ERRORES HTTP (4xx, 5xx, 999)
    if (error.response) {
      return buildErrorResponse({
        code: error.response.status,
        status: mapHttpCodeToStatus(error.response.status),
        message: error.response.data?.message || error.response.statusText || `HTTP Error ${error.response.status}`,
        httpStatus: error.response.status,
        httpStatusText: error.response.statusText,
        axiosCode: error.code || null,
        serverStatusCode: error.response.data?.statusCode || null,
        serverData: error.response.data || null
      });
    }
    
    // 🌐 ERRORES DE RED (sin response)
    if (error.request) {
      return buildErrorResponse({
        code: 0,
        status: "NETWORK_ERROR",
        message: error.message || "Network error",
        httpStatus: null,
        httpStatusText: null,
        axiosCode: error.code || null,
        serverStatusCode: null,
        serverData: null
      });
    }
    
    // 🤷 ERROR DESCONOCIDO (configuración, etc.)
    return buildErrorResponse({
      code: -1,
      status: "UNKNOWN_ERROR",
      message: error.message || "Unknown error",
      httpStatus: null,
      httpStatusText: null,
      axiosCode: error.code || null,
      serverStatusCode: null,
      serverData: null
    });
  }
}

export default invokeApi;